import { AutogenModelAppointmentStatus, AutogenRowAppointmentStatus } from "./autogen/AutogenModelAppointmentStatus";

export class ModelAppointmentStatus extends AutogenModelAppointmentStatus<RowAppointmentStatus> {
    constructor() {
        super(RowAppointmentStatus);
    }
}

export class RowAppointmentStatus extends AutogenRowAppointmentStatus {
}